import { render } from "./UICard.vue?vue&type=template&id=76eb655b&scoped=true&bindings={}"
import script from "./UICard.vue?vue&type=script&lang=js"
export * from "./UICard.vue?vue&type=script&lang=js"

import "./UICard.vue?vue&type=style&index=0&id=76eb655b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76eb655b"

export default script